import { toast } from "react-toastify";

export const validateOTP = (otp) => {
  // Check if email is empty or invalid
  if (!otp?.otp1 || otp?.otp1.trim() === "") {
    toast.error("Invalid OTP");
    return false;
  }else  if (!otp?.otp2 || otp?.otp2.trim() === "") {
        toast.error("Invalid OTP");
    return false;
  }else  if (!otp?.otp3 || otp?.otp3.trim() === "") {
        toast.error("Invalid OTP");
    return false;
  }else  if (!otp?.otp4 || otp?.otp4.trim() === "") {
        toast.error("Invalid OTP");
    return false;
  }else  if (!otp?.otp5 || otp?.otp5.trim() === "") {
        toast.error("Invalid OTP");
    return false;
  }else  if (!otp?.otp6 || otp?.otp6.trim() === "") {
        toast.error("Invalid OTP");
    return false;
  }
 
  // If all validations pass
  return true;
};
